import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject"

@Injectable()
export class EventNameService {
  eventName= new BehaviorSubject<any>('initialState');
  pageInit=  new BehaviorSubject<any>('initialState');
  constructor() { }

  updateEventName(event){
    this.eventName.next(event);
  }

  getEventName(){
    return this.eventName.asObservable();
  }

  updatePageInit(event){
    this.pageInit.next(event);
  }

  getPageInit(){
    return this.pageInit.asObservable();
  }

}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/event-name.service.ts